import {useEffect, useRef, useState} from "react";

export default function NyugdijSlider(this: any, props: FieldRenderProps & {enableDead: boolean,page:number}) {
    const enableDead = props.enableDead
    const start = props.value?.[0] ?? 20
    const middle = props.value?.[1] ?? 65
    const end = props.value?.[2] ?? 75
    const boundingBox = useRef<HTMLDivElement>(null)


    const [startPosition, setStartPosition] = useState((boundingBox.current?.clientWidth ?? 0) / 100 * start)
    const [middlePosition, setMiddlePosition] = useState((boundingBox.current?.clientWidth ?? 0) / 100 * middle)
    const [endPosition, setEndPosition] = useState((boundingBox.current?.clientWidth ?? 0) / 100 * end)

    useEffect(() => {
        setPositions()
    }, [props.page, props.value]);

    function setPositions() {
        setStartPosition((boundingBox.current?.clientWidth ?? 0) / 100 * start)
        setMiddlePosition((boundingBox.current?.clientWidth ?? 0) / 100 * middle)
        setEndPosition((boundingBox.current?.clientWidth ?? 0) / 100 * end)
    }

    const handleMouseDown = (reason: any) => {
        window.onmouseup = handleMouseUp
        window.onmousemove = (event) => handleMouseMove(event, reason)
        //document.getElementsByClassName("MuiDialog-root")[0].style.cursor = "pointer"
    }

    const handleMouseUp = () => {
        //document.getElementsByClassName("MuiDialog-root")[0].style.cursor = ""
        window.onmouseup = null;
        window.onmousemove = null;
    }

    const handleMouseMove = (event: any, reason: any) => {
        if (reason && boundingBox.current) {
            const left = boundingBox.current.getBoundingClientRect().left
            const newPosition = event.clientX - left;
            let newVal = newPosition / boundingBox.current.clientWidth * 100
            newVal = Math.floor(newVal)
            if (reason === "middle") {
                if ((!enableDead || newVal < end - 1) && newVal <= 100 && newVal >= 65 && newVal > start + 6)
                    props.onChange([start, newVal, end])
            } else if (reason === "end") {
                if (newVal <= 100 && newVal > middle)
                    props.onChange([start, middle, newVal])
            }
        }
    }
    handleMouseMove.bind(this)
    handleMouseUp.bind(this)

    return (
        <div className={"flex-col justify-center flex w-full items-center gap-2 select-none"}>
            <div className={"w-full h-8 flex flex-col justify-end mb-4"}>
                <div className={"bg-white border-primary border w-full rounded-full h-2 relative"} ref={boundingBox}>
                    <div className={"bg-primary rounded-full h-2 absolute top-0 left-0"}
                         style={{width: middlePosition}}></div>
                    {enableDead &&
                        <div className={"bg-constructive rounded-full h-2 absolute top-0"}
                             style={{width: endPosition - middlePosition, left: middlePosition}}></div>
                    }
                    <div className={"text-sm absolute -translate-x-1/2 -top-7"}
                         style={{left: startPosition}}>életkor ({start})
                    </div>
                    <div className={"text-sm absolute -translate-x-1/2 " + ((((end-middle) < 7 && enableDead) || (middle-start) < 9) ? "top-3" : "-top-7" )}
                         style={{left: middlePosition}}>{middle} évesen
                    </div>
                    {enableDead &&
                        <div className={"text-sm absolute -translate-x-1/2 -top-7"} style={{left: endPosition}}>{end}†</div>
                    }

                    <div
                        className={"bg-white border-primary border w-3 h-3 rounded-full -translate-x-1/2 absolute -top-0.5"}
                        style={{left: startPosition}}></div>

                    <div onMouseDown={() => handleMouseDown("middle")}
                         className={"bg-white border-primary border-2 w-6 h-6 rounded-full absolute -top-2 -ml-2 cursor-pointer"}
                         style={{left: middlePosition}}></div>
                    {enableDead &&
                        <div onMouseDown={() => handleMouseDown("end")}
                             className={"bg-white border-constructive border-2 w-6 h-6 rounded-full absolute -top-2 -ml-2 cursor-pointer"}
                             style={{left: endPosition}}></div>
                    }


                </div>
            </div>
            {enableDead ?
                <div className={"text-center font-bold"}>nyugdíjas évek száma: <div
                    className={"inline-block uppercase text-primary font-normal"}>{end - middle} év</div></div>
                : <div className={"text-center font-bold"}>várható évek nyugdíjig: <div
                    className={"inline-block uppercase text-primary font-normal"}>{middle - start} év</div></div>
            }
        </div>
    )
}